"use client";

import { useEffect } from "react";
import { usePathname, useSearchParams } from "next/navigation";

export function MetaContextNavigationSync(): null {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    window.saMetaRefreshContext?.();
  }, [pathname, searchParams]);

  useEffect(() => {
    const refresh = () => window.saMetaRefreshContext?.();

    window.addEventListener("hashchange", refresh);
    window.addEventListener("popstate", refresh);

    return () => {
      window.removeEventListener("hashchange", refresh);
      window.removeEventListener("popstate", refresh);
    };
  }, []);

  return null;
}